import IconNavigation from "../../../../Site/gulp/scripts/typescript/modules/icon-navigation";

const iconNavigations = document.querySelectorAll('.js-icon-navigation') as NodeListOf<HTMLDivElement>;

for (let i = 0; i < iconNavigations.length; i++) {
	new IconNavigation(iconNavigations[i]);
}
